import React from 'react';

import { CircularProgress } from '@mui/material';

export const Loader = ({ size = 20, color = 'primary' }) => (
  <CircularProgress color={color} size={size} />
);
